// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1wyW5","bigColWidth":"Table_bigColWidth__cAzkl","biggerColWidth":"Table_biggerColWidth__3e3Aa","row":"Table_row__16f4K","col":"Table_col__HOcCb"};